import styled from "@emotion/styled";
import { RequiredThemeKeys } from "@smartsheet/sds-theme-internal";
import { Spacer } from "../../layout";
import { paginationTheme } from "../paginationTheme";

interface ContainerProps {
    themeMode: RequiredThemeKeys;
    variant: "inline" | "floating";
}

function shouldForwardProp(propName: string): boolean {
    switch (propName) {
        case "themeMode":
            return false;
    }
    return true;
}

export const Container = styled(Spacer, {
    shouldForwardProp,
})<ContainerProps>(
    ({ themeMode, variant }) => `
    background: ${paginationTheme.container.background(themeMode)};
    height: ${paginationTheme.container.height(themeMode)};
    display: flex;
    align-items: center;
    padding: ${paginationTheme.container.padding(themeMode)};
    border-radius: ${paginationTheme.container.borderRadius(themeMode)};
    width: fit-content;
    box-shadow: ${variant === "floating" ? `${paginationTheme.container.boxShadow(themeMode)}` : "none"};
    box-sizing: border-box;
`
);
